function fallback(text, element) {
    return new Promise((resolve, reject) => {
        const input = document.createElement("input");
        input.value = text;
        input.style.position = "absolute";
        input.style.top = "0";
        input.style.left = "0";

        const parent = element ? element.parentElement : document.body;

        parent.appendChild(input);
        input.focus();
        input.select();

        try {
            document.execCommand("copy");
        } catch (err) {
            reject(new Error(`Unable to copy text to clipboard: ${err}`));
        }

        input.remove();
        resolve();
    });
}

export function copyToClipboard(text, element) {
    if (!navigator.clipboard) {
        return fallback(text, element);
    }

    return new Promise((resolve) => {
        navigator.clipboard.writeText(text).then(
            () => {
                resolve();
            },
            () => {
                resolve(fallback(text, element));
            },
        );
    });
}
